(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[698],{

/***/ 91951:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/product-registration/register-offline-product",
      function () {
        return __webpack_require__(31313);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64821:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/back-arrow.e6d9293c.svg","height":19,"width":25});

/***/ }),

/***/ 29754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StepNavigator_StepNavigator; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/core/StepNavigator/StepNav.module.scss
var StepNav_module = __webpack_require__(78112);
var StepNav_module_default = /*#__PURE__*/__webpack_require__.n(StepNav_module);
;// CONCATENATED MODULE: ./src/components/checkout/ShippingFiller.jsx


const ShippingFiller = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "shipping-address",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "shipping-address__form",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "shipping-address__checkout-fast",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "shimmer-loading__para30 shimmer width-250"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "shipping-address__checkout-fast-cta",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "shimmer-loading__para30 shimmer width-170"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "shipping-form container px-0 mx-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "shipping-form__required-fields",
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "shimmer-loading__input shimmer"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "shimmer-loading__input shimmer"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 shipping-form__pr10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__input shimmer"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 shipping-form__pl10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__input shimmer"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-9 shipping-form__pr10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__input shimmer"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-3 shipping-form__pl10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__input shimmer"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 shipping-form__pr10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__input shimmer"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-3 mb-20 shipping-form__pl10 shipping-form__pr10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__input shimmer"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-3 shipping-form__pl10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__input shimmer"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "shimmer-loading__input shimmer"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var checkout_ShippingFiller = (ShippingFiller);

// EXTERNAL MODULE: ./store/features/checkoutSlice.js
var checkoutSlice = __webpack_require__(60475);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./components/checkout/v1/checkoutAnalytics.js
var checkoutAnalytics = __webpack_require__(82883);
// EXTERNAL MODULE: ./components/RegisterOfflineProduct/v1/RegisterOfflineHelper.js
var RegisterOfflineHelper = __webpack_require__(15661);
;// CONCATENATED MODULE: ./components/core/StepNavigator/StepNavigator.jsx












const StepNavigator = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { data , placeOrder , handleSuccess , handlePaymentStep =()=>{} , checkoutMode ="" , addrSet =false , changeCurStep =()=>{}  } = param;
    const [curStep, setCurStep] = (0,react.useState)(checkoutMode === "one-step" && addrSet === "true" ? 1 : 0);
    const statusCode = {
        PENDING: "pending",
        COMPLETE: "complete",
        EDIT: "edit"
    };
    const [status, setStatus] = (0,react.useState)(data === null || data === void 0 ? void 0 : data.map((d, i)=>{
        if (i === 0 && checkoutMode === "one-step" && addrSet === "true") {
            return statusCode.COMPLETE;
        }
        return statusCode.PENDING;
    }));
    const [open, setOpen] = (0,react.useState)(data === null || data === void 0 ? void 0 : data.map(()=>false));
    const stepNavRef = (0,react.useRef)([]);
    const dispatch = (0,es/* useDispatch */.I0)();
    const handleNext = ()=>{
        updateStatus(curStep, statusCode.COMPLETE);
        if (curStep < (data === null || data === void 0 ? void 0 : data.length) - 1) {
            setCurStep(curStep + 1);
        }
    };
    (0,react.useImperativeHandle)(ref, ()=>({
            handleNext
        }));
    const handleEdit = (step)=>{
        window.pageLoad = false;
        if (step === 0) {
            var ref;
            if (((ref = data[0]) === null || ref === void 0 ? void 0 : ref.label) === "Personal Information") {
                (0,RegisterOfflineHelper/* editButtonAnalyticsEventInfoStep */.Pu)("personal information");
            } else {
                (0,checkoutAnalytics/* editCartAnalytics */.ak)();
            }
        }
        if (step === 1) {
            var ref1;
            if (((ref1 = data[1]) === null || ref1 === void 0 ? void 0 : ref1.label) === "Product Information") {
                (0,RegisterOfflineHelper/* editButtonAnalyticsEventInfoStep */.Pu)("product information");
            } else {
                (0,checkoutAnalytics/* editDeliveryAnalytics */.Hi)();
            }
        }
        setCurStep(step);
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("set-step", changeStep);
        window.pageLoad = true;
        return ()=>{
            document.removeEventListener("set-step", changeStep);
        };
    }, []);
    const changeStep = (e)=>{
        if (curStep !== 0) {
            var ref;
            var ref1;
            setCurStep((ref1 = e === null || e === void 0 ? void 0 : (ref = e.detail) === null || ref === void 0 ? void 0 : ref.count) !== null && ref1 !== void 0 ? ref1 : 0);
        }
    };
    (0,react.useEffect)(()=>{
        if (curStep !== 3) {
            dispatch((0,checkoutSlice/* setIsPaymentInfoAction */.hK)(false));
        }
        changeCurStep(curStep);
        handlePaymentStep(curStep);
        dispatch((0,checkoutSlice/* setCheckoutAction */.BZ)(curStep));
    }, [
        curStep
    ]);
    const handleOpen = (step, label)=>{
        const newOpen = [
            ...open
        ];
        newOpen[step] = !open[step];
        setOpen(newOpen);
        addAnalyticsData(step, newOpen, label);
    };
    const addAnalyticsData = (step, newOpen, label)=>{
        var ref, ref1, ref2, ref3;
        const collapseExpand = newOpen[step] ? "expand" : "collapse";
        const type = label === null || label === void 0 ? void 0 : label.toLowerCase();
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const onlineOrOffline = ((ref = window.adobeDataLayer[1]) === null || ref === void 0 ? void 0 : (ref1 = ref.page) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.category) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subCategoryID) === null || ref3 === void 0 ? void 0 : ref3.includes("offline")) ? "offline" : "online";
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "my account:register ".concat(onlineOrOffline, " kohler products:").concat(type, ":accordion ").concat(collapseExpand),
            eventName: "my account:register ".concat(onlineOrOffline, " kohler products:").concat(type, ":accordion ").concat(collapseExpand),
            eventMsg: "n/a",
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: collapseExpand,
            internalLinkPosition: "register products",
            internalLinkType: "my account:navigation",
            internalLinkURL: "n/a",
            internalLinkZoneName: "my account:register ".concat(onlineOrOffline, " kohler products:").concat(type)
        };
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    };
    const updateStatus = (step, code)=>{
        const newStatus = [
            ...status
        ];
        newStatus[step] = code;
        if (code === statusCode.EDIT) {
            if (step !== 0 && !(window === null || window === void 0 ? void 0 : window.pageLoad)) {
                var ref;
                (ref = stepNavRef.current[step]) === null || ref === void 0 ? void 0 : ref.scrollIntoView(true);
            }
            for(let i = step + 1; i < (data === null || data === void 0 ? void 0 : data.length); i++){
                newStatus[i] = statusCode.PENDING;
            }
        }
        setStatus(newStatus);
    };
    (0,react.useEffect)(()=>updateStatus(curStep, statusCode.EDIT), [
        curStep
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (StepNav_module_default()).stepNavWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "step-nav",
            children: data === null || data === void 0 ? void 0 : data.map((param, i)=>/*#__PURE__*/ {
                let { label , editButtonAnalytics , content: Component , props , ref =null  } = param;
                return (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()({
                        "step-nav__step": true,
                        "step-nav__step--active": i === curStep,
                        "step-nav__step--done": status[i] === statusCode.COMPLETE
                    }),
                    id: "step-nav-step-".concat(i),
                    tabIndex: "-1",
                    ref: (element)=>stepNavRef.current.push(element),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "step-nav__number d-none d-lg-block",
                            children: i + 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "step-nav__content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "step-nav__title",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "step-nav__title-container",
                                            "aria-current": i === curStep ? "step" : "",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "step-nav__number--mobile",
                                                        children: [
                                                            i + 1,
                                                            " "
                                                        ]
                                                    }),
                                                    label
                                                ]
                                            })
                                        }),
                                        curStep > i && !props.hideEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            role: "button",
                                            ariaLabel: "Edit ".concat(label),
                                            customClass: "step-nav__edit-btn",
                                            className: editButtonAnalytics ? "gbh-data-layer" : "",
                                            size: "small",
                                            type: "ghost",
                                            label: "Edit",
                                            onClick: ()=>handleEdit(i)
                                        }),
                                        status[i] === statusCode.COMPLETE && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            tabIndex: "0",
                                            role: "button",
                                            "aria-label": "Edit ".concat(label),
                                            "aria-expanded": open[i],
                                            className: "step-nav__plus ".concat(open[i] ? "--open" : ""),
                                            onClick: ()=>handleOpen(i, label),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "line line-1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "line line-2"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                label === "Shipping" && status[i] === statusCode.PENDING && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    role: "group",
                                    className: "step-nav__component--open",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_ShippingFiller, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    role: "group",
                                    className: "step-nav__component ".concat(status[i] === statusCode.EDIT || status[i] === statusCode.COMPLETE && open[i] ? "--open" : "", " ").concat(status[i] === statusCode.EDIT || status[i] === statusCode.COMPLETE && open[i] ? "order-summary-mobile-block" : ""),
                                    children: [
                                        status[i] !== statusCode.PENDING && /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                                            status: status[i],
                                            statusCode: statusCode,
                                            ...props,
                                            onNext: handleNext,
                                            placeOrder: placeOrder,
                                            handleSuccess: handleSuccess,
                                            curStep: curStep,
                                            ref: ref
                                        }),
                                        curStep > i && lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            role: "button",
                                            tabIndex: open[i] ? 0 : 1,
                                            ariaLabel: "Edit ".concat(label),
                                            className: editButtonAnalytics ? "gbh-data-layer" : "",
                                            "data-gbh-data-layer": editButtonAnalytics || null,
                                            customClass: "step-nav__edit-btn--mobile",
                                            size: "small",
                                            type: "ghost",
                                            label: "Edit",
                                            onClick: ()=>handleEdit(i),
                                            useDefaultClass: true
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, i);
            })
        })
    });
});
/* harmony default export */ var StepNavigator_StepNavigator = (StepNavigator);
StepNavigator.propTypes = {
    data: (prop_types_default()).array.isRequired
};


/***/ }),

/***/ 31313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ register_offline_product; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./hooks/usePageAuth.js
var usePageAuth = __webpack_require__(48375);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx
var GlobalPageHeader = __webpack_require__(81169);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx + 1 modules
var GlobalPageFooter = __webpack_require__(74859);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./store/index.js + 1 modules
var store = __webpack_require__(45094);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
;// CONCATENATED MODULE: ./i18n/useRegisterOfflineProducti18n.js

const useRegisterOfflineProducti18n = (param)=>{
    let { authorData: { backToMyProducts , registerProductsTitle , productInfoDescription , address , addComment , addAnotherProductToRegister , reviewAnswer , submitRegistration , confirmationMainCopy , confirmationSubCopy , productRegistered , whereToFind , kohler , sterlingProduct , productLabel , productLiterature , invoice , stamped , troubleShooting , serialNumberPlaceholder  } = {}  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        backToMyProducts: backToMyProducts !== null && backToMyProducts !== void 0 ? backToMyProducts : t("kf.registerOfflineProduct.label.backToMyProducts"),
        registerProductsTitle: registerProductsTitle !== null && registerProductsTitle !== void 0 ? registerProductsTitle : t("kf.registerOfflineProduct.label.registerProductsTitle"),
        productInfoDescription: productInfoDescription !== null && productInfoDescription !== void 0 ? productInfoDescription : t("kf.registerOfflineProduct.label.productInfoDescription"),
        requiredFields: t("kf.registerOfflineProduct.label.requiredFields"),
        productInformationTitle: t("kf.registerOfflineProduct.label.productInformationTitle"),
        modelNumber: t("kf.registerOfflineProduct.label.modelNumber"),
        serialNumber: t("kf.registerOfflineProduct.label.serialNumber"),
        serialNumberOptional: serialNumberPlaceholder !== null && serialNumberPlaceholder !== void 0 ? serialNumberPlaceholder : t("kf.registerOfflineProduct.label.serialNumberOptional"),
        placeOfPurchase: t("kf.registerOfflineProduct.label.placeOfPurchase"),
        productDetails: t("kf.registerOfflineProduct.label.productDetails"),
        datePurchase: t("kf.registerOfflineProduct.label.datePurchase"),
        dealerName: t("kf.registerOfflineProduct.label.dealerName"),
        getOTP: t("kf.registerOfflineProduct.label.getOTP"),
        mobileVerified: t("kf.registerOfflineProduct.label.mobileVerified"),
        verifyMobile: t("kf.registerOfflineProduct.label.verifyMobile"),
        registerMobile: t("kf.registerOfflineProduct.label.registerMobile"),
        pinCode: t("kf.registerOfflineProduct.label.pinCode"),
        countryCode: t("kf.registerOfflineProduct.label.countryCode"),
        emailAddress: t("kf.registerOfflineProduct.label.email"),
        modelNumberSupportLink: t("kf.registerOfflineProduct.label.modelNumberSupportLink"),
        registrationInformationTitle: t("kf.registerOfflineProduct.label.registrationInformationTitle"),
        firstName: t("kf.registerOfflineProduct.label.firstName"),
        lastName: t("kf.registerOfflineProduct.label.lastName"),
        address: address !== null && address !== void 0 ? address : t("kf.registerOfflineProduct.label.address"),
        city: t("kf.registerOfflineProduct.label.city"),
        state: t("kf.registerOfflineProduct.label.state"),
        zipCode: t("kf.registerOfflineProduct.label.zipCode"),
        installationDate: t("kf.registerOfflineProduct.label.installationDate"),
        addComment: addComment !== null && addComment !== void 0 ? addComment : t("kf.registerOfflineProduct.label.addComment"),
        next: t("kf.registerOfflineProduct.label.next"),
        save: t("kf.registerOfflineProduct.label.save"),
        addAnotherProductToRegister: addAnotherProductToRegister !== null && addAnotherProductToRegister !== void 0 ? addAnotherProductToRegister : t("kf.registerOfflineProduct.label.addAnotherProductToRegister"),
        reviewTitle: t("kf.registerOfflineProduct.label.reviewTitle"),
        reviewQuestion: t("kf.registerOfflineProduct.label.reviewQuestion"),
        reviewAnswer: reviewAnswer,
        termCondition1: t("kf.registerOfflineProduct.label.termsCondition1"),
        termCondition2: t("kf.registerOfflineProduct.label.termsCondition2"),
        terms: t("kf.registerOfflineProduct.label.terms"),
        policy: t("kf.registerOfflineProduct.label.policy"),
        submitRegistration: submitRegistration !== null && submitRegistration !== void 0 ? submitRegistration : t("kf.registerOfflineProduct.label.submitRegistration"),
        confirmationMainCopy: (productLength)=>confirmationMainCopy !== null && confirmationMainCopy !== void 0 ? confirmationMainCopy : t("kf.registerOfflineProduct.label.confirmationMainCopy", {
                productCount: productLength
            }),
        confirmationSubCopy: confirmationSubCopy !== null && confirmationSubCopy !== void 0 ? confirmationSubCopy : t("kf.registerOfflineProduct.label.confirmationSubCopy"),
        reviewProducts: t("kf.registerOfflineProduct.label.reviewProducts"),
        productRegistrationSummary: t("kf.registerOfflineProduct.label.productRegistrationSummary"),
        productRegistered: productRegistered !== null && productRegistered !== void 0 ? productRegistered : t("kf.registerOfflineProduct.label.productRegistered"),
        backToHome: t("kf.registerOfflineProduct.label.backToHome"),
        mobileNumberError: t("kf.registerOfflineProduct.label.mobileNumberError"),
        mobileNumberValid: t("kf.registerOfflineProduct.label.mobileValidNumberError"),
        firstNameError: t("kf.registerOfflineProduct.label.firstNameError"),
        lastNameError: t("kf.registerOfflineProduct.label.lastNameError"),
        emailError: t("kf.registerOfflineProduct.label.emailError"),
        emailValidError: t("kf.registerOfflineProduct.label.emailValidError"),
        addressError: t("kf.registerOfflineProduct.label.addressError"),
        cityError: t("kf.registerOfflineProduct.label.cityError"),
        stateError: t("kf.registerOfflineProduct.label.stateError"),
        zipCodeError: t("kf.registerOfflineProduct.label.zipCodeError"),
        pinCodeError: t("kf.registerOfflineProduct.error.pinCodeError"),
        pinCodeValidError: t("kf.registerOfflineProduct.label.pincodeValidNumberError"),
        validZipcode: t("kf.registerOfflineProduct.label.validZipcode"),
        modelNumberError: t("kf.registerOfflineProduct.label.modelNumberError"),
        validModelNumberError: t("kf.registerOfflineProduct.label.modelNumberError"),
        serialNumberError: t("kf.registerOfflineProduct.label.serialNumberError"),
        validSerialNumberError: t("kf.registerOfflineProduct.label.validSerialNumberError"),
        placeOfPurchaseError: t("kf.registerOfflineProduct.label.placeOfPurchaseError"),
        remove: t("kf.registerOfflineProduct.label.remove"),
        dateOfInstallation: t("kf.registerOfflineProduct.label.dateOfInstallation"),
        drag: t("kf.registerOfflineProduct.label.drag"),
        drop: t("kf.registerOfflineProduct.label.drop"),
        or: t("kf.registerOfflineProduct.label.or"),
        uploadPhoto: t("kf.registerOfflineProduct.label.uploadPhoto"),
        addPhoto: t("kf.registerOfflineProduct.label.addPhoto"),
        whereToFind: whereToFind !== null && whereToFind !== void 0 ? whereToFind : t("kf.registerOfflineProduct.label.whereToFind"),
        kohler: kohler !== null && kohler !== void 0 ? kohler : t("kf.registerOfflineProduct.label.kohler"),
        sterlingProduct: sterlingProduct !== null && sterlingProduct !== void 0 ? sterlingProduct : t("kf.registerOfflineProduct.label.sterlingProduct"),
        yourorder: t("kf.registerOfflineProduct.label.yourorder"),
        productLabel: productLabel !== null && productLabel !== void 0 ? productLabel : t("kf.registerOfflineProduct.label.productLabel"),
        productLiterature: productLiterature !== null && productLiterature !== void 0 ? productLiterature : t("kf.registerOfflineProduct.label.productLiterature"),
        invoice: invoice !== null && invoice !== void 0 ? invoice : t("kf.registerOfflineProduct.label.invoice"),
        stamped: stamped !== null && stamped !== void 0 ? stamped : t("kf.registerOfflineProduct.label.stamped"),
        troubleShooting: troubleShooting !== null && troubleShooting !== void 0 ? troubleShooting : t("kf.registerOfflineProduct.label.troubleShooting"),
        uploadLimitError: t("kf.registerOfflineProduct.error.imageUploadMaxFilesExceed"),
        uploadFileSizeError: t("kf.registerOfflineProduct.error.imageUploadMaxFileSizeExceed"),
        provideImageError: t("kf.registerOfflineProduct.error.provideImageError"),
        uploadFileTypeError: t("kf.registerOfflineProduct.error.imageUploadFileTypes"),
        validDateError: t("kf.registerOfflineProduct.label.validDateError"),
        maxDateError: t("kf.registerOfflineProduct.label.maxDateError"),
        serverError: t("kf.registerOfflineProduct.error.serverError"),
        siteLabel: t("kf.registerOfflineProduct.label.site"),
        productError: t("kf.registerOfflineProduct.error.productError"),
        dateOfPurchaseError: t("kf.registerOfflineProduct.error.dateOfPurchaseError"),
        ariaLabel: {
            imageRemove: t("kf.registerOfflineProduct.label.aria.removeImage"),
            next: t("kf.registerOfflineProduct.label.aria.next"),
            removeEmpty: t("kf.registerOfflineProduct.label.aria.removeEmpty"),
            removeProduct: (model)=>t("kf.registerOfflineProduct.label.aria.removeProduct", {
                    model
                })
        },
        genericError: t("kf.error.message.genericError")
    };
    return i18n;
};
/* harmony default export */ var i18n_useRegisterOfflineProducti18n = (useRegisterOfflineProducti18n);

// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./components/core/PageLoader/PageLoader.jsx + 1 modules
var PageLoader = __webpack_require__(41600);
// EXTERNAL MODULE: ./components/RegisterOfflineProduct/v1/RegisterOfflineHelper.js
var RegisterOfflineHelper = __webpack_require__(15661);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./src/store/features/myProductSlice.js
var myProductSlice = __webpack_require__(2570);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./public/icons/back-arrow.svg
var back_arrow = __webpack_require__(64821);
// EXTERNAL MODULE: ./components/core/StepNavigator/StepNavigator.jsx + 1 modules
var StepNavigator = __webpack_require__(29754);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./components/RegisterOfflineProduct/v1/RegisterProductConfirmation/index.module.scss
var index_module = __webpack_require__(30379);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./components/RegisterOfflineProduct/v1/RegisterProductConfirmation/index.jsx







const RegisterProductConfirmation = (param)=>{
    let { staticText , myProductsPath , customerDetails: { phone ={} , email ={} , firstName ={} , lastName ={} , address ={} , city ={} , state ={} , pinCode ={}  } , productDetails =[]  } = param;
    var ref, ref1, ref2;
    const regConfirmRef = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        const offlileConfirmation = regConfirmRef.current;
        offlileConfirmation.focus();
    }, []);
    console.log(productDetails, "prodeDetails");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()).registerProductConfirmationWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "registration-confirmation",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-confirmation-section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container kf-react-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row mx-0 px-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "register-offline-confirmation",
                                className: "col-12 product-confirmation-section-container",
                                role: "status",
                                tabIndex: "0",
                                ref: regConfirmRef,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "content-left",
                                        children: [
                                            staticText.confirmationMainCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "confirmation-main-copy",
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(staticText.confirmationMainCopy(productDetails.length))
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "confirmation-sub-copy",
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(staticText.confirmationSubCopy)
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "content-right",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            className: "gbh-data-layer",
                                            "data-gbh-data-layer": (0,RegisterOfflineHelper/* getOfflineReviewProductsAnalytics */.oP)(myProductsPath, productDetails),
                                            label: staticText.backToHome,
                                            to: myProductsPath,
                                            type: "black",
                                            useDefaultClass: true
                                        })
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-summary-section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container kf-react-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row mx-0 px-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12 px-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-summary-title",
                                        children: staticText.productRegistrationSummary
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-summary-list",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "registration-information-review",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title",
                                                    children: staticText.registrationInformationTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "registration-data",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: "+91 ".concat(phone === null || phone === void 0 ? void 0 : phone.value)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: email === null || email === void 0 ? void 0 : email.value
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                firstName.value,
                                                                " ",
                                                                lastName.value
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: address.value
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                pinCode.value,
                                                                ", ",
                                                                city.value,
                                                                ", ",
                                                                state.value
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-summary-list",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "registration-information-review",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title",
                                                    children: "Products Registered ".concat((ref2 = moment_default()((ref = productDetails[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.dateOfPurchase) === null || ref1 === void 0 ? void 0 : ref1.value)) === null || ref2 === void 0 ? void 0 : ref2.format("DD/MM/YYYY"))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-info-result",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        children: productDetails.map((item, i)=>{
                                                            var ref, ref1, ref2, ref3, ref4;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "product-data",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: (ref = item.productDetails) === null || ref === void 0 ? void 0 : ref.value
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: (ref1 = item.serialNumber) === null || ref1 === void 0 ? void 0 : ref1.value
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: (ref2 = item.dealerName) === null || ref2 === void 0 ? void 0 : ref2.value
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: (ref4 = moment_default()((ref3 = item.dateOfPurchase) === null || ref3 === void 0 ? void 0 : ref3.value)) === null || ref4 === void 0 ? void 0 : ref4.format("DD/MM/YYYY")
                                                                        })
                                                                    ]
                                                                })
                                                            }, i);
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: "custom-button-width gbh-data-layer",
                                        "data-gbh-data-layer": (0,RegisterOfflineHelper/* getProductConfirmationEventInfo */.fv)(myProductsPath, productDetails),
                                        label: staticText.backToHome,
                                        to: myProductsPath,
                                        type: "black",
                                        useDefaultClass: true
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v1_RegisterProductConfirmation = (RegisterProductConfirmation);

// EXTERNAL MODULE: ./components/RegisterOfflineProduct/v1/RegisterOfflineProductView/index.module.scss
var RegisterOfflineProductView_index_module = __webpack_require__(41315);
var RegisterOfflineProductView_index_module_default = /*#__PURE__*/__webpack_require__.n(RegisterOfflineProductView_index_module);
;// CONCATENATED MODULE: ./src/components/RegisterOfflineProduct/v1/RegisterOfflineProductView/index.jsx









const RegisterOfflineProductView = (param)=>{
    let { staticText ={} , steps =[] , isSuccess =false , myProductsPath ="" , productDetails =[] , customerDetails =[]  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((RegisterOfflineProductView_index_module_default()).registerOfflineProductViewWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "register-offline-product",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()({
                        "register-offline-product__go-back-main": true,
                        "register-offline-product__go-back-main-confirmation": isSuccess
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container kf-react-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row mx-0 px-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 px-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "register-offline-product__go-back ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                        href: myProductsPath,
                                        className: "arrow-back gbh-data-layer",
                                        "data-gbh-data-layer": (0,RegisterOfflineHelper/* getBackToProductsAnalytics */.xX)(isSuccess, myProductsPath),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: back_arrow/* default */.Z === null || back_arrow/* default */.Z === void 0 ? void 0 : back_arrow/* default.src */.Z.src,
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "link",
                                                children: (0,helper.sanitizeInnerHtml)(staticText.backToMyProducts)
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                }),
                isSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_RegisterProductConfirmation, {
                    staticText: staticText,
                    myProductsPath: myProductsPath,
                    customerDetails: customerDetails,
                    productDetails: productDetails
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container kf-react-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row mx-0 px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 px-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "register-offline-product__main-container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "register-offline-product__main-header-top",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "main-title",
                                            children: staticText.registerProductsTitle
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StepNavigator/* default */.Z, {
                                        data: steps
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v1_RegisterOfflineProductView = (RegisterOfflineProductView);

// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(95828);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/core/Autocomplete/Autocomplete.jsx
var Autocomplete = __webpack_require__(81511);
// EXTERNAL MODULE: ./components/RegisterOfflineProduct/v1/ImageUpload/index.jsx + 1 modules
var ImageUpload = __webpack_require__(32753);
// EXTERNAL MODULE: ./public/icons/calendar.svg
var calendar = __webpack_require__(65110);
// EXTERNAL MODULE: ./components/RegisterOfflineProduct/v1/ProductForm/index.module.scss
var ProductForm_index_module = __webpack_require__(90157);
var ProductForm_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductForm_index_module);
// EXTERNAL MODULE: ./utils/findStore.js
var findStore = __webpack_require__(42605);
;// CONCATENATED MODULE: ./components/RegisterOfflineProduct/v1/ProductForm/index.jsx












const ProductForm = (param)=>{
    let { id ="" , data ={} , title ="" , staticText ={} , suggestions =[] , dealersDetail =[] , handleData =()=>{} , removeForm =()=>{} , setCurrentForm =()=>{} , clearSuggestions =()=>{}  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const [dealerNames, setDealerNames] = (0,react.useState)([]);
    const getDealerFunction = async ()=>{
        const response = await (0,findStore/* getDealerNames */.Uk)();
        let totalRecords = response === null || response === void 0 ? void 0 : response.result.totalRecords;
        const res = await (0,findStore/* getDealerNames */.Uk)(totalRecords);
        var ref;
        let dealers = (ref = res === null || res === void 0 ? void 0 : res.result.data.stores.map((dealer)=>({
                name: dealer.storeName
            }))) !== null && ref !== void 0 ? ref : [];
        setDealerNames(dealers);
    };
    (0,react.useEffect)(()=>{
        getDealerFunction();
    }, []);
    const handleProductDetails = (e)=>{
        handleData({
            ...data,
            productDetails: {
                value: e.target.value,
                error: false,
                message: ""
            }
        });
        if (e.target.value.length > 2) {
            setCurrentForm(id);
        } else {
            Boolean(suggestions.length) && clearSuggestions();
        }
    };
    const changeDateFormat = (date)=>{
        if (date) {
            const dateVal = moment_default()(date).format("MM/DD/YYYY");
            handleData({
                ...data,
                dateOfPurchase: {
                    value: dateVal,
                    error: false,
                    message: ""
                }
            });
        } else {
            handleData({
                ...data,
                dateOfPurchase: {
                    value: "",
                    error: false,
                    message: ""
                }
            });
        }
    };
    const handleValidation = async (field)=>{
        if (field === "product") {
            var ref;
            if (!(data === null || data === void 0 ? void 0 : (ref = data.productDetails) === null || ref === void 0 ? void 0 : ref.value)) {
                handleData({
                    ...data,
                    productDetails: {
                        ...data === null || data === void 0 ? void 0 : data.productDetails,
                        error: true,
                        message: staticText.productError
                    }
                });
            }
        }
        if (field === "dateOfPurchase") {
            var ref1;
            if (!(data === null || data === void 0 ? void 0 : (ref1 = data.dateOfPurchase) === null || ref1 === void 0 ? void 0 : ref1.value)) {
                handleData({
                    ...data,
                    dateOfPurchase: {
                        ...data === null || data === void 0 ? void 0 : data.dateOfPurchase,
                        error: true,
                        message: staticText.dateOfPurchaseError
                    }
                });
            }
        }
    };
    // const dataList =
    //   dealersDetail.map(dealer => {
    //     return { name: dealer.value }
    //   })
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((ProductForm_index_module_default()).productFormWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "product-form",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-from-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-section",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-box-row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "modelNumber-".concat(id),
                                        type: "text",
                                        value: data === null || data === void 0 ? void 0 : (ref = data.productDetails) === null || ref === void 0 ? void 0 : ref.value,
                                        maxLength: 250,
                                        placeholder: "".concat(staticText.productDetails),
                                        label: "".concat(staticText.productDetails),
                                        showError: data === null || data === void 0 ? void 0 : (ref1 = data.productDetails) === null || ref1 === void 0 ? void 0 : ref1.error,
                                        errorMessage: data === null || data === void 0 ? void 0 : (ref2 = data.productDetails) === null || ref2 === void 0 ? void 0 : ref2.message,
                                        onInput: (e)=>handleProductDetails(e),
                                        onChange: (e)=>handleProductDetails(e),
                                        onBlur: ()=>handleValidation("product"),
                                        ariaLabel: title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-box-row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "serialNumber-".concat(id),
                                        type: "text",
                                        value: data === null || data === void 0 ? void 0 : (ref3 = data.serialNumber) === null || ref3 === void 0 ? void 0 : ref3.value,
                                        maxLength: 40,
                                        placeholder: "".concat(staticText.serialNumber),
                                        label: "".concat(staticText.serialNumber),
                                        showError: data === null || data === void 0 ? void 0 : (ref4 = data.serialNumber) === null || ref4 === void 0 ? void 0 : ref4.error,
                                        errorMessage: data === null || data === void 0 ? void 0 : (ref5 = data.serialNumber) === null || ref5 === void 0 ? void 0 : ref5.message,
                                        onInput: (e)=>handleData({
                                                ...data,
                                                serialNumber: {
                                                    value: e.target.value,
                                                    error: false,
                                                    message: ""
                                                }
                                            }),
                                        onChange: (e)=>handleData({
                                                ...data,
                                                serialNumber: {
                                                    value: e.target.value,
                                                    error: false,
                                                    message: ""
                                                }
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-box-row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
                                        id: "product-registeration-dealer-name-".concat(id),
                                        onInput: (val)=>handleData({
                                                ...data,
                                                dealerName: {
                                                    value: val,
                                                    error: false,
                                                    message: ""
                                                }
                                            }),
                                        onChange: (val)=>handleData({
                                                ...data,
                                                dealerName: {
                                                    value: val,
                                                    error: false,
                                                    message: ""
                                                }
                                            }),
                                        value: data === null || data === void 0 ? void 0 : (ref6 = data.dealerName) === null || ref6 === void 0 ? void 0 : ref6.value,
                                        data: dealerNames,
                                        label: "".concat(staticText.dealerName)
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "kf-react-datepicker",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                                        selected: Date.parse(data.dateOfPurchase.value),
                                        dateFormat: "dd/MM/yyyy",
                                        customInput: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            id: id,
                                            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: calendar/* default.src */.Z.src,
                                                alt: "calendar-icon"
                                            }),
                                            placeholder: "".concat(staticText.datePurchase),
                                            label: "".concat(staticText.datePurchase),
                                            showError: data === null || data === void 0 ? void 0 : (ref7 = data.dateOfPurchase) === null || ref7 === void 0 ? void 0 : ref7.error,
                                            errorMessage: data === null || data === void 0 ? void 0 : (ref8 = data.dateOfPurchase) === null || ref8 === void 0 ? void 0 : ref8.message
                                        }),
                                        id: "installationDate-".concat(id),
                                        onInput: (date)=>changeDateFormat(date),
                                        onChange: (date)=>changeDateFormat(date),
                                        minDate: new Date("01/01/2001"),
                                        maxDate: new Date(),
                                        isClearable: !!Date.parse(data === null || data === void 0 ? void 0 : (ref9 = data.dateOfPurchase) === null || ref9 === void 0 ? void 0 : ref9.value),
                                        onBlur: ()=>handleValidation("dateOfPurchase")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "image-upload-section",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageUpload/* default */.Z, {
                                uploadButtonAnalytics: '{"eventAction":"my account:register non kohler products:product information:upload photos","eventName":"my account:register non kohler products:product information:upload photos","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"upload photos","internalLinkPosition":"register products","internalLinkType":"my account:navigation","internalLinkZoneName":"my account:register non kohler products:product information","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                data: data,
                                staticText: staticText,
                                handleData: handleData
                            })
                        })
                    ]
                }),
                id !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    role: "button",
                    className: "remove-link gbh-data-layer",
                    "data-gbh-data-layer": (0,RegisterOfflineHelper/* getRemoveOfflineProductsAnalytics */.qf)(),
                    onClick: removeForm,
                    children: staticText.remove
                })
            ]
        })
    });
};
/* harmony default export */ var v1_ProductForm = (ProductForm);

;// CONCATENATED MODULE: ./public/icons/plus.svg
/* harmony default export */ var plus = ({"src":"/_next/static/media/plus.f16a370a.svg","height":30,"width":30});
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./components/RegisterOfflineProduct/v1/ProductInformation.jsx








const ProductInformation = (param)=>{
    let { staticText ={} , data: propData , status ="" , statusCode ={} , suggestions =[] , getProductDetails =()=>{} , onNext =()=>{} , authorData ={} , clearSuggestions =()=>{} , dealersDetail  } = param;
    const emptyFormObj = {
        productDetails: {
            value: "",
            error: false,
            message: ""
        },
        serialNumber: {
            value: "",
            error: false,
            message: ""
        },
        dealerName: {
            value: "",
            error: false,
            message: ""
        },
        dateOfPurchase: {
            value: "",
            error: false,
            message: ""
        },
        customerImage: [],
        uploadedImage: []
    };
    const [data, setData] = (0,react.useState)(propData ? propData : [
        emptyFormObj
    ]);
    const [currentForm, setCurrentForm] = (0,react.useState)("");
    const handleData = (index, formData)=>{
        const newData = [
            ...data
        ];
        newData[index] = formData;
        setData(newData);
    };
    const handleRemove = (i)=>{
        const newData = [
            ...data
        ];
        newData.splice(i, 1);
        setData(newData);
    };
    const handleSubmit = ()=>{
        const { newData , valid , errorMessage  } = (0,RegisterOfflineHelper/* productInfoHandleSubmit */.SE)(data, staticText);
        setData(newData);
        getProductDetails(newData);
        if (valid) {
            (0,RegisterOfflineHelper/* addProductInformationAnalytics */.sg)("cmp:click", newData, "success");
            onNext();
        } else (0,RegisterOfflineHelper/* addProductInformationAnalytics */.sg)("cmp:click", newData, "failure", errorMessage);
    };
    const handleAddAnotherProd = (e)=>{
        setData([
            ...data,
            emptyFormObj
        ]);
        window.preActiveElement = e.target;
    };
    const checkDisabled = (data)=>{
        const isDisabled = data === null || data === void 0 ? void 0 : data.some((list)=>list.productDetails.error || !list.dateOfPurchase.value || list.productImages.length === 0);
        return isDisabled;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-information",
        children: status === statusCode.COMPLETE ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-info-result",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: data.map((item, i)=>{
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-data",
                            role: "presentation",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: item.productDetails.value
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: item.serialNumber.value
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: item.dealerName.value
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: (ref = moment_default()(item.dateOfPurchase.value)) === null || ref === void 0 ? void 0 : ref.format("DD/MM/YYYY")
                                })
                            ]
                        })
                    }, i);
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "product-information-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "product-model-url",
                    children: (authorData === null || authorData === void 0 ? void 0 : authorData.linkText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: authorData === null || authorData === void 0 ? void 0 : authorData.link,
                        className: "gbh-data-layer",
                        "data-gbh-data-layer": RegisterOfflineHelper/* modalNumberSupportLinkEventInfo */.q$,
                        target: (authorData === null || authorData === void 0 ? void 0 : authorData.linkToNewTab) ? "_blank" : "_blank",
                        rel: "noreferrer",
                        children: authorData === null || authorData === void 0 ? void 0 : authorData.linkText
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "product-info-description",
                    children: authorData.productInfoDescription ? (0,html_react_parser/* default */.ZP)(authorData.productInfoDescription) : staticText.productInfoDescription
                }),
                data && data.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductForm, {
                        staticText: staticText,
                        id: i,
                        data: data[i],
                        currentForm: currentForm,
                        suggestions: suggestions,
                        setCurrentForm: setCurrentForm,
                        removeForm: ()=>handleRemove(i),
                        handleData: (data)=>handleData(i, data),
                        clearSuggestions: clearSuggestions,
                        dealersDetail: dealersDetail
                    }, i)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "add-another-product",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "add-another-product-button gbh-data-layer",
                        "data-gbh-data-layer": (0,RegisterOfflineHelper/* getAddAnotherProductAnalytics */.mh)(),
                        onClick: handleAddAnotherProd,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "plus-icon",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: plus === null || plus === void 0 ? void 0 : plus.src,
                                        alt: ""
                                    }),
                                    " "
                                ]
                            }),
                            " ",
                            staticText.addAnotherProductToRegister
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "button-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        tag: "button",
                        ariaLabel: staticText.ariaLabel.next,
                        type: "black",
                        label: staticText.next,
                        onClick: ()=>handleSubmit(),
                        disabled: checkDisabled(data),
                        testid: "".concat(staticText.next, "-product-info"),
                        useDefaultClass: true
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v1_ProductInformation = (ProductInformation);

// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./src/components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(62863);
;// CONCATENATED MODULE: ./components/RegisterOfflineProduct/v1/RegisterOfflineProduct.jsx




















const RegistrationInformation = /*#__PURE__*/ (0,react.lazy)(()=>__webpack_require__.e(/* import() */ 6706).then(__webpack_require__.bind(__webpack_require__, 6706)));
const ReviewRegistration = /*#__PURE__*/ (0,react.lazy)(()=>__webpack_require__.e(/* import() */ 9770).then(__webpack_require__.bind(__webpack_require__, 69770)));
const RegisterOfflineProduct = (param)=>{
    let { data: authorData = {}  } = param;
    var ref, ref1;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { isAuth , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { dealerDetails: dealers = [] , placeOfPurchaseList  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { status =false , offlineRegistration: { suggestions =[] , invalidModelNumber =false , submitError =false , isDisabled =false  }  } = (0,es/* useSelector */.v9)(myProductSlice/* selectMyAccountState */.Ih);
    const staticText = i18n_useRegisterOfflineProducti18n(authorData);
    const [customerDetails, setCustomerDetails] = (0,react.useState)({});
    const [productDetails, setProductDetails] = (0,react.useState)([]);
    const [searchKeyword, setSearchKeyword] = (0,react.useState)("");
    const [generalCountry, setGeneralCountry] = (0,react.useState)("");
    const [legalPageLinks, setLegalPageLinks] = (0,react.useState)("");
    const [myProductsPath, setMyProductsPath] = (0,react.useState)("");
    const [isSuccess, setIsSuccess] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        getDealers();
        (0,config/* getConfig */.i)().then((config)=>{
            const country = get_default()(config, "internationalization.country", "");
            const legalPageLinks = get_default()(config, "legalPageData.map", {});
            const myProductsPath = (0,helper.getShortenedUrlwithGeneral)(get_default()(config, "general.myProductsPath", ""), config.general);
            setLegalPageLinks(legalPageLinks);
            setGeneralCountry(country);
            setMyProductsPath(myProductsPath ? myProductsPath : "/");
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (searchKeyword.length > 2) handleModelNumberSuggestion();
    }, [
        searchKeyword
    ]);
    const getDealers = async ()=>{
        await store/* store.dispatch */.h.dispatch((0,genericSlice/* getGenericListPath */.Ln)());
        await store/* store.dispatch */.h.dispatch((0,genericSlice/* getDealerDetails */.Np)());
    };
    const submitRegistration = ()=>{
        const productsDetail = (0,RegisterOfflineHelper/* getProductDetails */.KL)(productDetails);
        const body = {
            firstName: get_default()(customerDetails, "firstName.value", ""),
            lastName: get_default()(customerDetails, "lastName.value", ""),
            countryCode: "+91",
            mobile: get_default()(customerDetails, "phone.value", ""),
            email: get_default()(customerDetails, "email.value", ""),
            addressLine1: get_default()(customerDetails, "address.value", ""),
            city: get_default()(customerDetails, "city.value", ""),
            state: get_default()(customerDetails, "state.value", ""),
            pincode: get_default()(customerDetails, "pinCode.value", ""),
            isOnline: false,
            products: productsDetail
        };
        (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
            if (res.success) {
                api/* apim.post */.TH.post("/crm/product/registration", body).then((res)=>{
                    const { data: { status =""  } = {}  } = res;
                    if (status === "success") {
                        setIsSuccess(true);
                        (0,RegisterOfflineHelper/* addReviewRegistrationAnalytics */.VS)("cmp:click", "success", productDetails, "");
                    } else {
                        setIsSuccess(false);
                        var _genericError;
                        (0,RegisterOfflineHelper/* submitRegistrationGenericError */.YU)(productDetails, (_genericError = authorData.genericError) !== null && _genericError !== void 0 ? _genericError : staticText.genericError);
                    }
                }).catch((err)=>{
                    const { ERROR_MESSAGE: { GENERAL =""  }  } = constants["default"];
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: GENERAL,
                        isVisible: true
                    }));
                    var _genericError;
                    (0,RegisterOfflineHelper/* submitRegistrationGenericError */.YU)(productDetails, (_genericError = authorData.genericError) !== null && _genericError !== void 0 ? _genericError : staticText.genericError);
                    dispatch((0,myProductSlice/* setSubmitStatus */.TN)({
                        submitError: staticText.serverError,
                        isDisabled: false
                    }));
                    console.error(err);
                });
            } else {
                var _genericError;
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: (_genericError = authorData.genericError) !== null && _genericError !== void 0 ? _genericError : staticText === null || staticText === void 0 ? void 0 : staticText.genericError,
                    isVisible: true
                }));
            }
        });
    };
    const handleClearSuggestions = ()=>{
        setSearchKeyword("");
        dispatch((0,myProductSlice/* clearSuggestion */.dM)());
    };
    var _registrationInformationLabel, _productInformationLabel, _reviewLabel;
    const steps = [
        {
            label: (_registrationInformationLabel = authorData.registrationInformationLabel) !== null && _registrationInformationLabel !== void 0 ? _registrationInformationLabel : staticText.registrationInformationTitle,
            editButtonAnalytics: (0,RegisterOfflineHelper/* editButtonAnalyticsEventInfo */.fz)((ref = staticText.registrationInformationTitle) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
            content: RegistrationInformation,
            props: {
                staticText: staticText,
                productDetails: productDetails,
                getCustomerDetails: setCustomerDetails,
                data: customerDetails,
                title: staticText.registrationInformationTitle
            }
        },
        {
            label: (_productInformationLabel = authorData.productInformationLabel) !== null && _productInformationLabel !== void 0 ? _productInformationLabel : staticText.productInformationTitle,
            editButtonAnalytics: (0,RegisterOfflineHelper/* editButtonAnalyticsEventInfo */.fz)((ref1 = staticText.productInformationTitle) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
            content: v1_ProductInformation,
            props: {
                staticText: staticText,
                placeOfpurchaseList: placeOfPurchaseList,
                dealersDetail: dealers,
                getProductDetails: setProductDetails,
                productDetails: productDetails,
                getSuggestions: setSearchKeyword,
                clearSuggestions: handleClearSuggestions,
                suggestions: suggestions,
                searchKeyword: searchKeyword,
                invalidModelNumber: invalidModelNumber,
                checkInValidModelNumber: (val)=>dispatch((0,myProductSlice/* setInvalidModelNumber */.M_)(val)),
                title: staticText.productInformationTitle,
                authorData: authorData
            }
        },
        {
            label: (_reviewLabel = authorData.reviewLabel) !== null && _reviewLabel !== void 0 ? _reviewLabel : staticText.reviewTitle,
            content: ReviewRegistration,
            props: {
                staticText: staticText,
                submitRegistration: submitRegistration,
                legalPages: legalPageLinks,
                submitError: submitError,
                isDisabled: isDisabled
            }
        }
    ];
    const handleModelNumberSuggestion = debounce_default()(()=>{
        getModelNumberSuggestions();
    }, 500);
    const getModelNumberSuggestions = ()=>{
        const params = {
            q: searchKeyword,
            rows: 10,
            fq: [
                'language_s:("en")',
                '-Brand_ss:("PlumbingServiceParts")'
            ],
            fl: "variantList.sku_ss,customerFacingSKUList_ss,Brand_ss,Country_ss",
            start: 0,
            skuSearch: true
        };
        dispatch((0,myProductSlice/* getModelNumberSuggest */.u8)(params));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                loading: status === "loading"
            }),
            steps.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_RegisterOfflineProductView, {
                staticText: staticText,
                steps: steps,
                productDetails: productDetails,
                customerDetails: customerDetails,
                isSuccess: isSuccess,
                myProductsPath: myProductsPath
            })
        ]
    });
};
/* harmony default export */ var v1_RegisterOfflineProduct = (RegisterOfflineProduct);

// EXTERNAL MODULE: ./src/components/RegisterOfflineProduct/v1/RegisterOfflineProductFiller.jsx
var RegisterOfflineProductFiller = __webpack_require__(90458);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 98 modules
var AemGrid = __webpack_require__(72960);
;// CONCATENATED MODULE: ./src/pages/my-account/product-registration/register-offline-product.jsx











const RegisterOfflineProductPage = (param)=>{
    let { locale , tmpData: data , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analysticsScript , analyticsData , datalayerPageName , gbhDataLayerCustom  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,usePageAuth/* default */.Z)();
    (0,react.useEffect)(()=>{
        (0,helper.getDataLayerObj)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* setDatalayerPageName */.dN)(datalayerPageName));
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        return ()=>{
            dispatch((0,genericSlice/* setDatalayerPageName */.dN)(""));
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
        };
    }, []);
    const componentProps = (0,helper.formatOfflineRegisterPropsData)(data);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader/* default */.Z, {
                header: header,
                title: data.title,
                globalScripting: globalScript,
                analysticsScript: analysticsScript
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
                data: data,
                count: 0,
                offlineProducts: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_RegisterOfflineProduct, {
                        data: componentProps
                    }),
                offlineProductsFiller: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterOfflineProductFiller/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter/* default */.Z, {
                footer: footer,
                footerScripting: footerScript
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var register_offline_product = (RegisterOfflineProductPage);


/***/ }),

/***/ 90157:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productFormWrapper":"ProductForm_productFormWrapper__wWPe_"};

/***/ }),

/***/ 41315:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"registerOfflineProductViewWrapper":"RegisterOfflineProductView_registerOfflineProductViewWrapper__ib_xH"};

/***/ }),

/***/ 30379:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"registerProductConfirmationWrapper":"RegisterProductConfirmation_registerProductConfirmationWrapper__CpU3d"};

/***/ }),

/***/ 78112:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stepNavWrapper":"StepNav_stepNavWrapper__PZZMo"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6351,1966,7333,8153,33,1433,6051,4697,9774,2888,179], function() { return __webpack_exec__(91951); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);